import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { type CanMatchFn, type Route, Router } from '@angular/router';

import { filter, map, take } from 'rxjs';

import { AppPath, type RouteData } from '@kernel';

import { AuthStore } from './auth.store';
import { matchAuth } from './auth.util';

export const authGuard: CanMatchFn = (route: Route) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const decide = () => {
    if (!authStore.isAuthenticated()) return router.createUrlTree([AppPath.Login]);

    const { roles, permissions, match } = (route.data ?? {}) as RouteData;

    if (roles && !matchAuth(roles, match, (r) => authStore.hasRole(r))) {
      return router.createUrlTree([AppPath.Unauthorized]);
    }

    if (permissions && !matchAuth(permissions, match, (p) => authStore.hasPermission(p))) {
      return router.createUrlTree([AppPath.Unauthorized]);
    }

    return true;
  };

  if (authStore.initialized()) return decide();

  return toObservable(authStore.initialized).pipe(filter(Boolean), take(1), map(decide));
};
